// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mentor_span {

    font-size: 14px;

    font-weight: 400;

    --tw-text-opacity: 1;

    color: rgb(99 99 99 / var(--tw-text-opacity, 1))
}

.mentor_p {

    display: flex;

    flex-direction: column;

    font-weight: 700;

    --tw-text-opacity: 1;

    color: rgb(34 34 34 / var(--tw-text-opacity, 1))
}
`, "",{"version":3,"sources":["webpack://./src/pages/doyenAccess/components/mentors/mentors.css"],"names":[],"mappings":"AACE;;IAAA,eAA6C;;IAA7C,gBAA6C;;IAA7C,oBAA6C;;IAA7C;AAA6C;;AAI7C;;IAAA,aAA6C;;IAA7C,sBAA6C;;IAA7C,gBAA6C;;IAA7C,oBAA6C;;IAA7C;AAA6C","sourcesContent":[".mentor_span {\n  @apply text-[#636363] text-[14px] font-normal;\n}\n\n.mentor_p {\n  @apply flex flex-col text-[#222222] font-bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
